import React from "react";
import { Link, Route } from "react-router-dom";

import RequireAuth from "../components/RequireAuth";
import { AUTH_LEVELS } from "../lib/globals";
import Organization, {
    loader as OrgLoader,
} from "../pages/LeagueManagement/Organizations/components/Organization";
import OrgManagementLayout from "../pages/OrgManagement/Layout";

export default (
    <Route element={<RequireAuth allowedUserLevels={AUTH_LEVELS.org} />}>
        <Route
            path="org-management"
            element={<OrgManagementLayout />}
            handle={{
                crumb: () => (
                    <Link to="/org-management">Organization Management</Link>
                ),
            }}
        >
            <Route
                index
                loader={OrgLoader}
                element={<Organization />}
                handle={{ header: () => "Organization Management" }}
            />
        </Route>
    </Route>
);
